import "./Calendar.css"
import React from 'react'
import { useState, useEffect, useRef } from "react"
import { useNavigate, Link } from "react-router-dom"
import PrivateNavbar from '../../layouts/PrivateNavbar'
import PrivateSidebar from '../../layouts/PrivateSidebar'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { dayOfWeek, dayOfWeekShort, yearMonthDayToday } from '../../util/helperfunctions'
import Table from 'react-bootstrap/Table';
import { config } from '../../constants/Constants'
import jwt_decode from "jwt-decode"
import toast, { Toaster } from 'react-hot-toast'
import { yearMonth, yearMonthDay, incrementYearMonth, decrementYearMonth, yearMonthPlusDay } from '../../util/helperfunctions'
import CalendarItem from "../../components/CalendarItem"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export default function Calendar() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [jwt, setJwt] = useState()
  const [errors, setErrors] = useState()
  useEffect(() => {
    const jwt = JSON.parse(localStorage.getItem(config.WELLBEINGv1_JWT))
    if (jwt) {
      let decodedJwt = jwt_decode(jwt)
      let currentDate = new Date()
      if (decodedJwt.exp * 1000 < currentDate.getTime()) {
        localStorage.setItem(config.WELLBEINGv1_JWT, null)
        navigate("/signin")
      } else {
        setJwt(jwt)
      }
    } else {
      navigate("/signin")
    }
  }, [])

  const calendarTimeElement = useRef()
  const calendarEventElement = useRef()
  const calendarNoteElement = useRef()

  const [selectedDay, setSelectedDay] = useState()
  const [selectedYearMonth, setSelectedYearMonth] = useState()  // yyyy-mm
  useEffect(() => {
    setSelectedYearMonth(yearMonth())
  }, [])
  useEffect(() => {
    setSelectedDay(yearMonthDayToday())
  }, [])
  const incrementSelectedYearMonth = () => {
    const nextYearMonth = incrementYearMonth(selectedYearMonth);
    setSelectedYearMonth(nextYearMonth);
    setSelectedDay(yearMonthPlusDay(nextYearMonth, 1));
  }
  const decrementSelectedYearMonth = () => {
    const prevYearMonth = decrementYearMonth(selectedYearMonth);
    setSelectedYearMonth(prevYearMonth);
    setSelectedDay(yearMonthPlusDay(prevYearMonth, 1));
  }

  const handleAdd = () => {
    handleShow()
  }

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [calendarScoreList, setCalendarScoreList] = useState()
  useEffect(() => {
    if (selectedYearMonth === null) {
      return
    }
    setErrors(null)
    setLoading(true)
    setCalendarScoreList(null)
    if (jwt === null || jwt === undefined) {
      setLoading(false)
      return
    }

    fetch(config.BASE_URL + "/calendar?" + new URLSearchParams({
      m: selectedYearMonth
    }), {
      headers: {
        "content-type": "application/json",
        "authorization": "Bearer " + jwt
      },
      method: "Get"
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      }
      return res.json().then(data => {
        throw data
      })
    }).then(data => {
      setCalendarScoreList(data)
      console.log(data)
      setLoading(false)
    }).catch(err => {
      setErrors(err)
      setLoading(false)
    })
  }, [selectedYearMonth])


  const [calendarItemObjList, setCalendarItemObjList] = useState()
  useEffect(() => {
    setErrors(null)
    setLoading(true)
    if (jwt === null || jwt === undefined) {
      setLoading(false)
      return
    }
    if (selectedDay === null) {
      setLoading(false)
      return
    }

    fetch(config.BASE_URL + "/calendar/items?" + new URLSearchParams({
      d: selectedDay
    }), {
      headers: {
        "content-type": "application/json",
        "authorization": "Bearer " + jwt
      },
      method: "GET"
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      }
      return res.json().then(data => {
        throw data
      })
    }).then(data => {
      setCalendarItemObjList(data)
      setLoading(false)
    }).catch(err => {
      setErrors(err)
      setLoading(false)
    })
  }, [selectedDay])
  const handleOnClick = (cs, index) => {
    var skips = 0
    for (let i = 0; i < 42; i++)
      if (calendarScoreList[i] == -9000)
        skips++
      else
        break

    if (cs === -9000) return
    var day = index - skips + 1

    setSelectedDay(yearMonthPlusDay(selectedYearMonth, day))
  }

  const getColorClass = (score) => {
    switch (true) {
      case score == -9000:
        return "border m-0"
      case score == 0:
        return "border border-secondary m-0"
      case (score >= 4):
        return "border border-primary m-0 bg-danger"
      case (score >= 3):
        return "border border-primary m-0 bg-secondary"
      case (score >= 2):
        return "border border-primary m-0 bg-primary"
      case (score >= 1):
        return "border border-primary m-0 bg-info"
    }
  }

  const getMonthDay = (ms, index) => {
    var skips = 0
    for (let i = 0; i < 42; i++)
      if (calendarScoreList[i] == -9000)
        skips++
      else
        break

    if (ms === -9000) return
    var day = index - skips + 1
    return day
  }

  const setDeleteFunction = (id) => {
    fetch(config.BASE_URL + "/calendar/items/" + id, {
      headers: {
        "content-type": "application/json",
        "authorization": "Bearer " + jwt
      },
      method: "DELETE"
    }).then(res => {
      if (res.ok) {
        return res.json()
      }
      return res.json().then(data => {
        throw data
      })
    }).then(data => {
      setCalendarScoreList(data.calendarScores)
      setCalendarItemObjList(data.calendarItems)
      setLoading(false)
    }).catch(err => {
      console.log(err)
    })
  }


  const handleSubmit = (e) => {
    e.preventDefault()

    const calendarTime = calendarTimeElement.current.value
    const calendarEvent = calendarEventElement.current.value
    const calendarNote = calendarNoteElement.current.value

    fetch(config.BASE_URL + "/calendar/items", {
      headers: {
        "content-type": "application/json",
        "authorization": "Bearer " + jwt
      },
      method: "POST",
      body: JSON.stringify({
        "date": selectedDay,
        "time": calendarTime,
        "event": calendarEvent,
        "note": calendarNote
      })
    }).then(res => {
      if (res.status === 201) {
        return res.json()
      }
      return res.json().then(data => {
        throw data
      })
    }).then(data => {
      setCalendarScoreList(data.calendarScores)
      setCalendarItemObjList(data.calendarItems)
      setLoading(false)
    }).catch(err => {
      setErrors(err)
    })
    handleClose()
  }

  const calendarUI = (<>
    <div className="d-flex flex-wrap">
      <div className="flex-grow-1 col-md-6">

        <div className="pt-3">
          <p className="fs-3">Calendar</p>
        </div>

        <div className="card">
          <div className="card-box">
            <div className="input-group mb-2">
              <button className="btn btn-primary" type="button" onClick={() => decrementSelectedYearMonth()}>Prev</button>
              <span className="flex-grow-1 d-flex align-items-center justify-content-center">{selectedYearMonth}</span>
              <button className="btn btn-primary" type="button" onClick={() => incrementSelectedYearMonth()}>Next</button>
            </div>
          </div>
        </div>

        <Table className="text-end" bordered size="sm">
          <tbody>
            <tr>
              <td className="col-1 text-center">S</td>
              <td className="col-1 text-center">M</td>
              <td className="col-1 text-center">T</td>
              <td className="col-1 text-center">W</td>
              <td className="col-1 text-center">T</td>
              <td className="col-1 text-center">F</td>
              <td className="col-1 text-center">S</td>
            </tr>
            <tr>
              {(calendarScoreList) && <>
                {
                  calendarScoreList.slice(0, 7).map((cs, index) => {
                    return <td className="col-1" onClick={() => handleOnClick(cs, index)}><div className={getColorClass(cs)} style={{ height: 48 + 'px' }}><div className="text-center">{getMonthDay(cs, index)}</div></div></td>
                  })
                }
              </>}
            </tr>
            <tr>
              {(calendarScoreList) && <>
                {
                  calendarScoreList.slice(7, 14).map((cs, index) => {
                    return <td className="col-1" onClick={() => handleOnClick(cs, 7 + index)}><div className={getColorClass(cs)} style={{ height: 48 + 'px' }}><div className="text-center">{getMonthDay(cs, 7 + index)}</div></div></td>
                  })
                }
              </>}
            </tr>
            <tr>
              {(calendarScoreList) && <>
                {
                  calendarScoreList.slice(14, 21).map((cs, index) => {
                    return <td className="col-1" onClick={() => handleOnClick(cs, 14 + index)}><div className={getColorClass(cs)} style={{ height: 48 + 'px' }}><div className="text-center">{getMonthDay(cs, 14 + index)}</div></div></td>
                  })
                }
              </>}
            </tr>
            <tr>
              {(calendarScoreList) && <>
                {
                  calendarScoreList.slice(21, 28).map((cs, index) => {
                    return <td className="col-1" onClick={() => handleOnClick(cs, 21 + index)}><div className={getColorClass(cs)} style={{ height: 48 + 'px' }}><div className="text-center">{getMonthDay(cs, 21 + index)}</div></div></td>
                  })
                }
              </>}
            </tr>
            <tr>
              {(calendarScoreList) && <>
                {
                  calendarScoreList.slice(28, 35).map((cs, index) => {
                    return <td className="col-1" onClick={() => handleOnClick(cs, 28 + index)}><div className={getColorClass(cs)} style={{ height: 48 + 'px' }}><div className="text-center">{getMonthDay(cs, 28 + index)}</div></div></td>
                  })
                }
              </>}
            </tr>
            <tr>
              {(calendarScoreList) && <>
                {
                  calendarScoreList.slice(35, 42).map((cs, index) => {
                    return <td className="col-1" onClick={() => handleOnClick(cs, 35 + index)}><div className={getColorClass(cs)} style={{ height: 48 + 'px' }}><div className="text-center">{getMonthDay(cs, 35 + index)}</div></div></td>
                  })
                }
              </>}
            </tr>

          </tbody>
        </Table>


        {(loading) && (
          <div className="d-flex justify-content-center col-12 flex-grow-1">
            <div className="spinner-grow text-secondary">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>

        )}

        {(errors) && (
          <div className="alert alert-danger">
            {errors['error(s)']?.map(e => { return <p>{e}</p> })}
          </div>
        )}

      </div>

      <div className="flex-grow-1 col-md-6">
        <div className="card">
          <div className="card-header"></div>
          <div className="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <p>{dayOfWeek(selectedDay)}, {selectedDay}</p>
              <button type="button" class="btn btn-primary" onClick={() => handleAdd()}>Add Event</button>
            </div>
          </div>
        </div>
        {!calendarItemObjList ? null : (
          <>
            {
              calendarItemObjList.map((cio, index) => {
                return <CalendarItem calendarItemObj={cio} setDeleteFunction={(id) => setDeleteFunction(id)} />
              }
              )
            }
          </>
        )
        }
      </div>
    </div>

    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{dayOfWeek(selectedDay)}, {selectedDay}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Time: </label>
            <input type="time" className="form-control" ref={calendarTimeElement} />
          </div>
          <div className="mb-3">
            <label className="form-label">Event: </label>
            <input autoFocus type="text" className="form-control" ref={calendarEventElement} />
          </div>
          <div className="mb-3">
            <label className="form-label">Note: </label>
            <input type="text" className="form-control" ref={calendarNoteElement} />
            <p className="form-text">*optional</p>
          </div>
          <div class="d-flex justify-content-end">
            <button type="submit" className="btn btn-primary mb-3">Submit</button>
          </div>

        </form>
      </Modal.Body>
    </Modal>
  </>)

  return (<>
    <PrivateNavbar active="calendar" />
    <Container fluid>
      <Row>
        <Col lg="3" className="border d-none d-lg-block bg-light position-fixed p-0">
          <PrivateSidebar active="calendar" />
        </Col>
        <Col className="col-lg-9 offset-lg-3 col-md-12 offset-md-0">
          {calendarUI}
          <Toaster />
        </Col>
      </Row>
    </Container>
  </>)
}